<div class="layout-topbar" style="background-color: #02640d">
  <a class="layout-topbar-logo" routerLink="">
    <span class="text-white">Martin BBQ Admin Portal</span>
  </a>

  <button
    #menubutton
    class="p-link layout-menu-button layout-topbar-button text-white"
    (click)="layoutService.onMenuToggle()"
  >
    <i class="pi pi-bars"></i>
  </button>

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button text-white"
    (click)="accountMenu.toggle($event)"
    aria-haspopup="true"
    aria-controls="account-menu"
  >
    <i class="pi pi-user"></i>
  </button>

  <p-menu
    #accountMenu
    appendTo="body"
    [popup]="true"
    [model]="accountMenuItems"
    id="account-menu"
    styleClass="account-menu"
  ></p-menu>

  <div
    #topbarmenu
    class="layout-topbar-menu text-white"
    [ngClass]="{ 'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible }"
  ></div>
</div>
